import { render } from "./RecipeAdd.vue?vue&type=template&id=32935c90&scoped=true"
import script from "./RecipeAdd.vue?vue&type=script&lang=js"
export * from "./RecipeAdd.vue?vue&type=script&lang=js"

import "./recipeAdd.css?vue&type=style&index=0&id=32935c90&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32935c90"]])

export default __exports__